import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Alert, Box, Button, Link, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { GetUploadCardStatus } from "../../../Redux/Reducers/redux-slice-aspera-upload";
import { useAppSelector } from "../../../Redux/redux-store";
import UploadCard, { UploadCardHandle, UploadContext } from "../../Cards/UploadCard/upload-card";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { OpenLinkInNewTab } from "../../../Utils/helpers";
import { dciService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

type CloseClbProps = {
  confirm: boolean;
};

export type ModalUploadKdmFileElementProps = {
  objectId: number;
  onClose?: (props: CloseClbProps) => void;
};
export type ModalUploadKdmFileProps = CommonModalProps<ModalUploadKdmFileElementProps>;

const ModalUploadKdmFile = React.forwardRef<any, ModalUploadKdmFileProps>((props, ref) => {
  const { t } = useTranslation();
  const uploadCardIndex: number = 0;

  const { objectId, closeModal, onClose, ...modalProps } = props;

  const uploadCardStatus = useAppSelector((state) => GetUploadCardStatus(state, uploadCardIndex));
  const uploadCardRef = React.useRef<UploadCardHandle>(null);

  const handleCancelClick = () => {
    onClose && onClose({ confirm: false });
    closeModal();
  };

  const handleOnSuccessUpload = () => {
    onClose && onClose({ confirm: true });
    closeModal();
  };

  const handleUpload = () => {
    uploadCardRef.current?.performUpload();
  };

  return (
    <Modal
      {...modalProps}
      title={t("modal:title.uploadDkdmForCryptedDcp")}
      reference={ref}
      closeModal={handleCancelClick}
      width={600}
      footer={
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            variant="outlined"
            disabled={uploadCardStatus !== "readyToUpload"}
            color="success"
            onClick={handleUpload}
          >
            {t("button:performUpload")}
          </Button>
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
        </Stack>
      }
    >
      <Box>
        <UploadCard
          cardIndex={uploadCardIndex}
          ref={uploadCardRef}
          title={t("card:title.uploadYourFile")}
          objectId={objectId}
          format={{
            id: 0,
            name: "DKDM",
            objectType: ObjectType.MetadataDcpKdm,
            maxFileSizeMb: 1,
            acceptsFiles: { "application/octet-stream": [".xml"] },
            isUploaded: false,
            userHasRighToDelete: true,
            isUserDataMandatory: false,
          }}
          dropZoneOptions={{
            maxSize: 1024 * 1024,
            maxFiles: 1,
          }}
          coverPlaceholderIcon={<UploadFileIcon />}
          userHasRightToDelete={true}
          context={UploadContext.KdmFile}
          onSuccessUpload={handleOnSuccessUpload}
        />
      </Box>
      <Alert color="info" icon={<HelpCenterIcon />} sx={{ mt: 3 }}>
        {t("alert:info.dkdmIsUsefulInMediaSpot")}
        <br />
        <br />
        {t("modal:modalUploadKdmFile.body.alert.youCanDownloadHere")}
        <br />
        <br />
        <Link color="text.primary" underline="hover" onClick={() => dciService.DownloadKdmPublicCert()}>
          {t("modal:modalUploadKdmFile.body.alert.downloadCertificate")}
        </Link>
      </Alert>
    </Modal>
  );
});

export default ModalUploadKdmFile;
